import { Observable } from 'rxjs';
import { ChecklistItemViewModel } from '../../models/checklists/checklistItemViewModel';
import { ValidatedViewModel } from '../../viewModels/validatedViewModel';

/**
 * Abstraction for checklist item operations
 * Supports both normal and external user flows
 */
export abstract class ChecklistItemAbstraction {
  abstract add(checklistItem: ChecklistItemViewModel): Observable<ValidatedViewModel>;

  abstract update(checklistItem: ChecklistItemViewModel, externalShareId?: string): Observable<ChecklistItemViewModel>;

  abstract updateItems(checklistItems: ChecklistItemViewModel[], externalShareId?: string): Observable<ChecklistItemViewModel[]>;

  abstract delete(checklistItemId: number): Observable<ChecklistItemViewModel>;

  abstract getList(): Observable<ChecklistItemViewModel[]>;

  abstract getListByGlobalObjectId(globalObjectId: number, globalObjectType: number, externalShareId?: string): Observable<ChecklistItemViewModel[]>;

  abstract addFromTemplate(
    checklistTemplateIds: number[],
    globalObjectId: number,
    globalObjectType: number
  ): Observable<ChecklistItemViewModel[]>;
}
